"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canRetry = exports.retryWithDelay = void 0;
const wait = (ms) => new Promise((resolve) => {
    setTimeout(() => resolve(true), ms);
});
const retryWithDelay = async (fn, retries, interval, retryWhen, options) => {
    let error;
    while (retries >= 0) {
        try {
            return await fn();
        }
        catch (err) {
            error = error || err;
            await (0, exports.canRetry)(retries, retryWhen, options, error);
            await wait(interval);
            retries--;
        }
    }
};
exports.retryWithDelay = retryWithDelay;
const canRetry = async (retries, retryWhen, options, error) => {
    const retry = await retryWhen(error, options).catch(() => {
        throw error;
    });
    if (!retry || retries <= 0)
        throw error;
};
exports.canRetry = canRetry;
//# sourceMappingURL=retry.helper.js.map